import { render } from "./PixKeyVerificationForm.vue?vue&type=template&id=05086ccb"
import script from "./PixKeyVerificationForm.vue?vue&type=script&lang=js"
export * from "./PixKeyVerificationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__